import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppEvents } from 'src/app/app.config/app-events';
import { ConstantesApp } from 'src/app/app.config/constantes-app';
import { Cliente } from 'src/app/app.domain.models/cliente';
import { Colectivo } from 'src/app/app.domain.models/colectivo';
import { Poliza } from 'src/app/app.domain.models/poliza';
import { TipoPoliza } from 'src/app/app.domain.models/tipo-poliza';
import { ClienteApiService } from 'src/app/app.domain.services/cliente.api.service';
import { ColectivoApiService } from 'src/app/app.domain.services/colectivo.api.service';
import { TipoPolizaApiService } from 'src/app/app.domain.services/tipo-poliza.api.service';
import { EventBrokerService } from 'src/app/core.services/event-broker.service';
import { SesionService } from 'src/app/core.services/sesion.service';
import { Utilidades } from 'src/app/core.utilidades/utilidades';
import { CoberturaComponent } from '../../modales/cobertura/cobertura.component';
import { ModalPoliticaPrivacidadComponent } from '../../modales/modal-politica-privacidad/modal-politica-privacidad.component';
import { PolizaApiService } from 'src/app/app.modules/individual/domain.services/poliza.api.service';

@Component({
    selector: 'app-calcular-seguro',
    templateUrl: './calcular-seguro.component.html',
    styleUrls: ['./calcular-seguro.component.scss'],
})
export class CalcularSeguroComponent implements OnInit {

    @Output() colectivoActualizado = new EventEmitter<Colectivo>();
    private urlColectivo: string;

    readonly CONSTANTES_APP = ConstantesApp;

    acepto: boolean = false;
    declaracionVeraz: boolean = false;

    capitalCobertura: number = 100000;
    capitalAccidenteFallecimiento = this.capitalCobertura * 2;
    capitalAccidenteInvalidez = this.capitalCobertura * 2;

    opcionesCapital: number[] = [50000, 100000, 150000, 200000, 250000, 300000];
    opcionesCapitalOriginales: number[] = [...this.opcionesCapital];

    mostrarPrimerConjunto = true;
    showModalInfoCobertura = false;

    mostrarInputOtroCapital: boolean = false;

    cliente: Cliente;
    poliza: Poliza;
    mensajeValidacionForm: string = '';

    formSeguroUno!: FormGroup;
    formSeguroDos!: FormGroup;

    maxCapital!: number;

    formulario: string = "calcular-seguro";

    tipoPolizaList: TipoPoliza[] = [];

    fechaNacimientoCliente;

    constructor(
        private router: Router,
        public dialog: MatDialog,
        private sesion: SesionService,
        private translateService: TranslateService,
        private toastr: ToastrService,
        private clienteService: ClienteApiService,
        private polizaApiService: PolizaApiService,
        private tipoPolizaApiService: TipoPolizaApiService,
        private colectivoApiService: ColectivoApiService,
        private eventBrokerService: EventBrokerService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.sesion.clearSession();
        this.cliente = this.sesion.getCliente();
        if (!this.cliente) { this.cliente = new Cliente(); }
        this.fechaNacimientoCliente = this.cliente.fechaNacimiento;

        this.poliza = this.sesion.getPoliza();
        if (!this.poliza) { this.poliza = new Poliza(); }

        this.urlColectivo = this.activatedRoute.snapshot.paramMap.get('colectivo')!;
        if (!this.urlColectivo) {
            this.router.navigateByUrl(ConstantesApp.PATH_FORBIDDEN);
        }
    }

    async ngOnInit() {

        // this.poliza.colectivo = new Colectivo();

        const colectivo = await this.colectivoApiService.obtenerByUrl(this.urlColectivo);
        if (colectivo) {
            this.poliza.colectivo = colectivo;
            this.poliza.tipoSeguro.id = ConstantesApp.TIPO_SEGURO_COLECTIVO_ID;

            this.eventBrokerService.publishEvent(AppEvents.actualizarColectivo, this.poliza.colectivo);

            this.tipoPolizaList = await this.tipoPolizaApiService.listar();
            this.setTipoPoliza(this.CONSTANTES_APP.TIPO_POLIZA_FAMILIA);

            this.prepararFormularios();
        } else {
            this.router.navigateByUrl(ConstantesApp.PATH_FORBIDDEN);
        }
    }

    private prepararFormularios() {
        // Convertimos a Number porque llega como string
        const esOtroCapital = !this.opcionesCapital.includes(Number(this.poliza.capitalCobertura));

        this.maxCapital = 300000;

        this.formSeguroUno = new FormGroup({
            dia: new FormControl(this.fechaNacimientoCliente ? this.fechaNacimientoCliente.getDate() : '', [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(31)]),
            mes: new FormControl(this.fechaNacimientoCliente ? this.fechaNacimientoCliente.getMonth() + 1 : '', [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(12)]),
            anio: new FormControl(this.fechaNacimientoCliente ? this.fechaNacimientoCliente.getFullYear() : '', [Validators.required, Validators.min(1000), Validators.max(9999)]),
            cobertura: new FormControl(esOtroCapital ? 'otro' : this.poliza.capitalCobertura, [Validators.required]),
            otroCapital: new FormControl(this.poliza.capitalCobertura)
        });

        this.mostrarInputOtroCapital = esOtroCapital;

        this.formSeguroDos = new FormGroup({
            email: new FormControl(this.cliente.email, [Validators.required, Validators.pattern(ConstantesApp.REGEX_EMAIL_OPCIONAL)]),
            telefono: new FormControl(this.cliente.telefono, [Validators.minLength(9), Validators.pattern(ConstantesApp.REGEX_TELEFONO)]),
        });

        this.capitalAccidenteFallecimiento = this.poliza.capitalAccidenteFallecimiento;
        this.capitalAccidenteInvalidez = this.poliza.capitalAccidenteInvalidez;

        if (esOtroCapital) {
            this.formSeguroUno.controls['otroCapital'].setValidators([Validators.required, Validators.min(50000)]);
        } else {
            this.formSeguroUno.controls['otroCapital'].clearValidators();
        }
        this.formSeguroUno.controls['otroCapital'].updateValueAndValidity();

        this.formSeguroUno.get('dia')!.valueChanges.subscribe(() => this.actualizarSegunFechaNacimiento());
        this.formSeguroUno.get('mes')!.valueChanges.subscribe(() => this.actualizarSegunFechaNacimiento());
        this.formSeguroUno.get('anio')!.valueChanges.subscribe(() => this.actualizarSegunFechaNacimiento());
    }

    get formDos(): { [key: string]: AbstractControl } {
        return this.formSeguroDos.controls;
    }

    get formUno(): { [key: string]: AbstractControl } {
        return this.formSeguroUno.controls;
    }

    getError(data: any) {
        let transMessageError = Utilidades.obtenerErrorFormControl(data, this.formulario);
        if (transMessageError != "") return this.translateService.instant(transMessageError);
        return "";
    }

    formValido() {
        if (this.formSeguroUno.controls['dia'].errors || this.formSeguroUno.controls['mes'].errors || this.formSeguroUno.controls['anio'].errors) {
            this.toastr.error(this.translateService.instant('calcular-seguro.fecha.invalida'));
            return false;
        }
        if (this.formSeguroUno.valid) {
            if (Utilidades.esFechaValidaDiaMesAnio(this.formSeguroUno.controls['dia'].value, this.formSeguroUno.controls['mes'].value, this.formSeguroUno.controls['anio'].value)) {
                return true;
            } else {
                this.toastr.error(this.translateService.instant('calcular-seguro.fecha.invalida'));
            }
        }
        return false;
    }

    public siguiente() {

        if (!this.formValido()) {
            this.formSeguroUno.markAllAsTouched();
            return;
        }

        const edad = Utilidades.calcularEdadDiaMesAnio(this.formSeguroUno.controls['dia'].value, this.formSeguroUno.controls['mes'].value, this.formSeguroUno.controls['anio'].value);

        if (edad < 18 || edad > 65) {
            this.toastr.error(this.translateService.instant('calcular-seguro.fecha-nacimiento'));
            this.formSeguroUno.markAllAsTouched();
            return;
        }
        this.mostrarPrimerConjunto = false;

    }

    public setTipoPoliza(tipoPolizaId: number) {
        this.poliza.tipoPoliza = this.tipoPolizaList.find((t) => t.id === tipoPolizaId)!;
    }


    public verPrecio() {
        if (this.validarCamposVerPrecio()) {

            const fechaNacimientoUTC = new Date(Date.UTC(
                this.formSeguroUno.controls['anio'].value,
                this.formSeguroUno.controls['mes'].value - 1,
                this.formSeguroUno.controls['dia'].value
            ));

            this.cliente.fechaNacimiento = fechaNacimientoUTC;

            this.cliente.email = this.formSeguroDos.controls["email"].value;
            this.cliente.telefono = this.formSeguroDos.controls["telefono"].value;

            if (this.formSeguroUno.controls["cobertura"].value === 'otro') {
                this.poliza.capitalCobertura = this.formSeguroUno.controls["otroCapital"].value;
            } else {
                this.poliza.capitalCobertura = this.formSeguroUno.controls["cobertura"].value;
            }
            this.poliza.capitalAccidenteFallecimiento = this.poliza.capitalCobertura * 2;
            this.poliza.capitalAccidenteInvalidez = this.poliza.capitalCobertura * 2;

            this.poliza.fechaCreacion = new Date();

            this.clienteService.obtenerByEmail(this.cliente.email)
                .then((resCliente) => {
                    if (resCliente) {
                        // Actualizar la fecha de nacimiento y el telefono del cliente que viene de bbdd
                        resCliente.fechaNacimiento = this.cliente.fechaNacimiento;
                        resCliente.telefono = this.cliente.telefono;
                        this.cliente = resCliente;
                        this.clienteService.actualizar(this.cliente).then(() => {
                            this.sesion.setCliente(this.cliente);
                            this.crearActualizarPoliza(this.cliente);
                        });
                    } else {
                        // Para no pisar el cliente que hay en sesion, id de cliente pasa a undefined
                        this.cliente.id = undefined;
                        this.clienteService.crear(this.cliente).then(resCliente => {
                            this.cliente = resCliente;
                            this.sesion.setCliente(this.cliente);
                            this.crearActualizarPoliza(this.cliente);
                        });
                    }
                });

        } else {
            this.toastr.error(this.translateService.instant('form.generic.error.general'));
            this.formSeguroDos.markAllAsTouched();
        }
    }

    private crearActualizarPoliza(cliente: Cliente) {
        this.poliza.cliente.id = cliente.id!;

        this.poliza.archivoPoliza = undefined;
        this.poliza.archivoAstra = undefined;
        this.poliza.archivoAstraAnonimo = undefined;
        this.poliza.archivoSolicitud = undefined;
        this.poliza.archivoPoliza = undefined;
        this.poliza.archivoPolizaSimplificado = undefined;
        this.poliza.archivoReciboHipoteca = undefined;
        this.poliza.tipoEstado.id = ConstantesApp.TIPO_ESTADO_PENDIENTE_ID;

        if (this.poliza.id) {
            this.polizaApiService.obtenerById(this.poliza.id)
                .then((resPoliza) => {
                    if (resPoliza) {
                        // Actualizar el id de cliente por si ha cambiado
                        resPoliza.cliente.id = cliente.id!;
                        // Actualizar los capitales del poliza que viene de bbdd
                        resPoliza.capitalCobertura = this.poliza.capitalCobertura;
                        resPoliza.capitalAccidenteFallecimiento = this.poliza.capitalCobertura * 2;
                        resPoliza.capitalAccidenteInvalidez = this.poliza.capitalCobertura * 2;
                        this.poliza = resPoliza;
                        this.polizaApiService.actualizar(this.poliza).then(() => this.sesion.setPoliza(this.poliza));
                    } else {
                        this.polizaApiService.crear(this.poliza).then((resPoliza) => this.sesion.setPoliza(resPoliza));
                    }
                    this.router.navigateByUrl(ConstantesApp.PATH_COLECTIVOS_2_VER_PRECIO);
                });
        } else {
            this.polizaApiService.crear(this.poliza).then((resPoliza) => {
                resPoliza.beneficiarioList = this.poliza.beneficiarioList;
                resPoliza.capitalCobertura = this.poliza.capitalCobertura;
                resPoliza.capitalAccidenteFallecimiento = this.poliza.capitalCobertura * 2;
                resPoliza.capitalAccidenteInvalidez = this.poliza.capitalCobertura * 2;
                this.poliza = resPoliza
                this.sesion.setPoliza(this.poliza);
                this.router.navigateByUrl(ConstantesApp.PATH_COLECTIVOS_2_VER_PRECIO);
            });
        }
    }

    mostrarModalInfo() {
        const dialogRef = this.dialog.open(CoberturaComponent, {
            panelClass: 'custom-modal-small',
            data: { component: CoberturaComponent, mostrarBtnFooter: false },
        });

        dialogRef.afterClosed().subscribe((result) => { });
    }

    validarAcepto(): boolean {
        if (!this.acepto) {
            this.mensajeValidacionForm = this.translateService.instant('calcular-seguro.acetar.tratamiento-datos');
            return false;
        }
        return true;
    }

    validarDeclaracionVeraz(): boolean {
        if (!this.declaracionVeraz) {
            this.mensajeValidacionForm = this.translateService.instant('calcular-seguro.acetar.tratamiento-datos');
            return false;
        }
        return true;
    }

    validarCamposVerPrecio(): boolean {
        return this.formSeguroDos.valid && this.validarAcepto() && this.validarDeclaracionVeraz();
    }

    actualizarCapitalCobertura(event: Event) {
        const valorSeleccionado = (event.target as HTMLSelectElement).value;
        this.maxCapital = this.obtenerMaximoCapitalPermitido();

        if (valorSeleccionado === 'otro') {
            this.mostrarInputOtroCapital = true;
            this.formSeguroUno.get('otroCapital')!.setValidators([
                Validators.required,
                Validators.min(50000),
                Validators.max(this.maxCapital)
            ]);
        } else {
            this.mostrarInputOtroCapital = false;
            this.formSeguroUno.get('otroCapital')!.clearValidators();
        }
        this.formSeguroUno.get('otroCapital')!.updateValueAndValidity();
    }

    abrirModalInformativo(event: Event) {
        event.preventDefault();
        const dialogRef = this.dialog.open(ModalPoliticaPrivacidadComponent, {
            panelClass: 'custom-modal-info',
            data: { component: ModalPoliticaPrivacidadComponent, mostrarBtnFooter: false },
        });

        dialogRef.afterClosed().subscribe((result) => { });
    }

    actualizarSegunFechaNacimiento() {
        if (Utilidades.esFechaValidaDiaMesAnio(this.formSeguroUno.controls["anio"].value,
            this.formSeguroUno.controls["mes"].value - 1,
            this.formSeguroUno.controls["dia"].value)) {
            this.fechaNacimientoCliente = new Date(
                this.formSeguroUno.controls["anio"].value,
                this.formSeguroUno.controls["mes"].value - 1,
                this.formSeguroUno.controls["dia"].value
            );

            this.validarCapitalSegunEdad();
        }
    }

    obtenerMaximoCapitalPermitido(): number {
        const edad = Utilidades.calcularEdadDate(this.fechaNacimientoCliente);
        if (edad >= 18 && edad <= 55) {
            return 300000;
        } else {
            return 150000;
        }
    }

    validarCapitalSegunEdad() {
        const edad = Utilidades.calcularEdadDate(this.fechaNacimientoCliente);
        if (edad >= 18 && edad <= 55) {
            this.opcionesCapital = [...this.opcionesCapitalOriginales];
        } else if (edad > 55 && edad <= 65) {
            this.opcionesCapital = this.opcionesCapital.filter(c => c <= 150000);
        }

        if (this.formSeguroUno.controls['cobertura'].value == 'otro' && (edad >= 18 && edad <= 65)) {
            let maxCapital = edad >= 18 && edad <= 55 ? 300000 : 150000;
            if (this.formSeguroUno.controls['otroCapital'].value > maxCapital) {
                this.formSeguroUno.controls['otroCapital'].setValue(maxCapital);
            }
        }
    }

    retroceder(): void {
        this.mostrarPrimerConjunto = true;
    }
}
